module.exports = __webpack_public_path__ + "img/welfare-4.f6fc6928.png";